import { FeatureTour } from '@/types/tour'
import { ReleaseNote } from '@/types/releaseNotes'
import releaseNotesData from './release-notes-data.json'

/**
 * Get tours for a specific version
 */
export const getToursByVersion = (version: string): FeatureTour[] | null => {
    const typedData = releaseNotesData as ReleaseNote[]
    const note = typedData.find((n) => n.version === version)
    return note?.tours || null
}

/**
 * Get a specific tour by version and tour ID
 */
export const getTourById = (
    version: string,
    tourId: string
): FeatureTour | null => {
    const tours = getToursByVersion(version)
    return tours?.find((t) => t.id === tourId) || null
}

/**
 * Get all available tours across all versions
 */
export const getAllTours = (): Array<FeatureTour & { version: string }> => {
    const typedData = releaseNotesData as ReleaseNote[]
    const allTours: Array<FeatureTour & { version: string }> = []

    for (const note of typedData) {
        if (note.tours?.length) {
            for (const tour of note.tours) {
                allTours.push({ ...tour, version: note.version })
            }
        }
    }

    return allTours
}
